import Component from '../../../shared/component';

export default class AssetModal extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$nextButton = this.$element.find('.assetModal-arrow--next');
    this.$previousButton = this.$element.find('.assetModal-arrow--previous');

    this.bindEvents();
  }

  bindEvents() {
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePreviousClick = this.handlePreviousClick.bind(this);

    this.$nextButton.on('click.AssetModal', this.handleNextClick);
    this.$previousButton.on('click.AssetModal', this.handlePreviousClick);
  }

  unbindEvents() {
    this.$nextButton.off('click.AssetModal', this.handleNextClick);
    this.$previousButton.off('click.AssetModal', this.handlePreviousClick);
  }

  fetchData(url) {
    $.get(url).done((data) => this.handleAJAXSuccess(data));
  }

  handleAJAXSuccess(data) {
    this.displayData(data);
    this.$element.modal('show');
  }

  displayData(data) {
    this.$element
      .find('.assetModal-body-photo-image')
      .attr('src', data.assetable.photo.full.url);
    this.$element.find('.assetInfo-organization-title').html(data.title);
    this.$element
      .find('.assetInfo-organization-description')
      .html(data.description);

    this.refreshNavigationButton(this.$nextButton, data.next_asset_url);
    this.refreshNavigationButton(this.$previousButton, data.previous_asset_url);
  }

  refreshNavigationButton(element, url) {
    if (url) {
      element.show();
      element.data('resource-url', url);
    } else {
      element.hide();
    }
  }

  handleNextClick() {
    this.fetchData(this.$nextButton.data('resource-url'));
  }

  handlePreviousClick() {
    this.fetchData(this.$previousButton.data('resource-url'));
  }
}
